import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
};

export const Toast = async ({
  icon = "info",
  title,
  message,
  position = "bottom-right",
  ...options
}) => {
  const config = { ...defaultOptions, position, ...options };

  switch (icon) {
    case "success":
      toast.success(message, config);
      break;
    case "error":
      toast.error(message, config);
      break;
    case "warning":
      toast.warning(message, config);
      break;
    case "info":
    default:
      toast.info(message, config);
      break;
  }
};

export const ToastContainerWrapper = () => <ToastContainer closeButton={false} newestOnTop />;
